var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageupload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37695 32.633L15.4986 18.333L29.7586 36.6663",
    stroke: "#B2B5AD",
    strokeWidth: 3.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1673 16.6667C29.0083 16.6667 30.5007 15.1743 30.5007 13.3333C30.5007 11.4924 29.0083 10 27.1673 10C25.3264 10 23.834 11.4924 23.834 13.3333C23.834 15.1743 25.3264 16.6667 27.1673 16.6667Z",
    stroke: "#B2B5AD",
    strokeWidth: 3.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5007 36.6663H10.5007C6.81898 36.6663 3.83398 33.6813 3.83398 29.9997V9.99967C3.83398 6.31801 6.81898 3.33301 10.5007 3.33301H30.5007C34.1823 3.33301 37.1673 6.31801 37.1673 9.99967V29.9997C37.1673 33.6813 34.1823 36.6663 30.5007 36.6663Z",
    stroke: "#B2B5AD",
    strokeWidth: 3.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageupload);
export default __webpack_public_path__ + "static/media/image upload.8a28c6b70671af7309776db06d211db4.svg";
export { ForwardRef as ReactComponent };